import { GAME_W, BIRD_COUNT, BIRD_FORMATION, BIRD_Y_MIN, BIRD_Y_MAX, BIRD_WAVE_INTERVAL, FPS } from "./data";
import { landscape } from "./terrain";
import { bonusLayout } from "./bonus-layout";
import { coins, birdsFlocks, pickups, type PickupType } from "./entities";
import { getImage } from "./images";
import { Asset } from "assets.gen";
import { random } from "core/math";
import { camera } from "./camera";
import { hud } from "./hud";
import { MAX_LIVES } from "./data";
import { dt } from "lib/loop";

export function spawnCoin(): void {
  const img = getImage(Asset.gfx_coin);
  const w = img ? img.width : 5;
  const h = img ? img.height : 5;
  const x = camera.x + GAME_W;
  const px = x + w * 0.5;
  const { top, bottom } = landscape.getPlaceOffsets(px);
  const gap = bottom - top;
  if (gap < h + 5) return;
  const y = top + gap * bonusLayout.place - h * 0.5;
  coins.push({ x, y, w, h, active: true });
}

export function updateCoins(): void {
  for (let i = coins.length - 1; i >= 0; i--) {
    const c = coins[i];
    if (c.x + c.w < camera.x) {
      coins.splice(i, 1);
    }
  }
}

export function spawnBirds(): void {
  const spawnX = camera.x + GAME_W;
  const { top, bottom } = landscape.getPlaceOffsets(spawnX);
  const gap = bottom - top;
  if (gap < 15) return;
  const margin = 6;
  const y = (top + margin + random() * (gap - margin * 2 - 6)) | 0;

  const waveDir: number[] = [];
  const waveOffset: number[] = [];
  for (let i = 0; i < BIRD_COUNT; i++) {
    if (BIRD_FORMATION[i] > 0) {
      waveDir.push(1);
      waveOffset.push(BIRD_Y_MIN);
    } else {
      waveDir.push(-1);
      waveOffset.push(BIRD_Y_MAX);
    }
  }

  birdsFlocks.push({
    x: spawnX,
    y,
    active: true,
    _t: 0,
    _waveDir: waveDir,
    _waveOffset: waveOffset,
  });
}

export function spawnPickup(): void {
  const px = camera.x + GAME_W;
  const { top, bottom } = landscape.getPlaceOffsets(px);
  const gap = bottom - top;
  if (gap < 12) return;

  let type: PickupType;
  const fullHearts = hud._hearts.filter(h => h === 1).length;
  const hasLockedSlots = hud._hearts.some(h => h === -1);

  if (!hasLockedSlots && fullHearts >= MAX_LIVES) {
    type = "max_hp";
  } else if (fullHearts <= 1) {
    type = "heal";
  } else if (hasLockedSlots && fullHearts >= MAX_LIVES) {
    type = "max_hp";
  } else {
    type = "heal";
  }

  const margin = 6;
  const y = top + margin + random() * (gap - margin * 2 - 6);
  pickups.push({ x: px, y, w: 7, h: 7, type, active: true });
}

export function updatePickups(): void {
  for (let i = pickups.length - 1; i >= 0; i--) {
    const p = pickups[i];
    if (p.x + p.w < camera.x || !p.active) {
      pickups.splice(i, 1);
    }
  }
}

export function updateBirds(): void {
  for (let i = birdsFlocks.length - 1; i >= 0; i--) {
    const flock = birdsFlocks[i];
    if (!flock.active) {
      birdsFlocks.splice(i, 1);
      continue;
    }

    flock.x -= landscape.vx * 0.5 * dt;
    if (flock.x + 9 < camera.x) {
      birdsFlocks.splice(i, 1);
      continue;
    }

    flock._t += dt;
    if (flock._t >= BIRD_WAVE_INTERVAL / FPS) {
      flock._t -= BIRD_WAVE_INTERVAL / FPS;
      for (let j = 0; j < BIRD_COUNT; j++) {
        if (flock._waveDir[j] > 0) {
          flock._waveOffset[j]++;
          if (flock._waveOffset[j] >= BIRD_Y_MAX) flock._waveDir[j] = -1;
        } else {
          flock._waveOffset[j]--;
          if (flock._waveOffset[j] <= BIRD_Y_MIN) flock._waveDir[j] = 1;
        }
      }
    }
  }
}
